var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.997,
    height: 11.999,
    viewBox: "0 0 11.997 11.999"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.783.221a.742.742 0 00-1.228.263A4.857 4.857 0 015.38 2.949a8.192 8.192 0 01-3.88.813.748.748 0 00-.531 1.274L3.4 7.468 0 11.999l4.53-3.4 2.428 2.428a.73.73 0 00.244.163.749.749 0 001.035-.69 8.1 8.1 0 01.811-3.868 4.847 4.847 0 012.466-2.175.736.736 0 00.265-.169.749.749 0 000-1.059L8.786.219z",
    fill: "#cdcdcd"
  })));
}

export default SvgPin;